// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1g_La","col":"styles_col__2Oz24"};